// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6f455571","453":"406532a6","455":"0c94ef2a","977":"1f6ffce5"}[chunkId] + ".chunk.js";
};